import { Terminal, ChevronLeft, ChevronRight } from 'lucide-react'
import { useGeekMode } from '../contexts/GeekModeContext'

export default function GeekModeToggle() {
  const { isUnlocked, isEnabled, toggleEnabled, togglePanel, isPanelOpen } = useGeekMode()

  // Don't show if not unlocked
  if (!isUnlocked) {
    return null
  }

  return (
    <div className="flex items-center space-x-2">
      {/* Toggle switch */}
      <button
        onClick={toggleEnabled}
        className="relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none"
        style={{
          background: isEnabled
            ? 'linear-gradient(135deg, #00ff00 0%, #00aa00 100%)'
            : 'rgba(100, 116, 139, 0.3)',
          boxShadow: isEnabled ? '0 0 10px rgba(0, 255, 0, 0.5)' : 'none',
        }}
        title={isEnabled ? 'Disable GeekMode' : 'Enable GeekMode'}
      >
        <span
          className="inline-block w-4 h-4 transform rounded-full transition-transform"
          style={{
            background: isEnabled ? '#000' : 'rgba(148, 163, 184, 0.8)',
            transform: isEnabled ? 'translateX(24px)' : 'translateX(4px)',
          }}
        />
      </button>

      {/* Panel toggle button - only show when enabled */}
      {isEnabled && (
        <button
          onClick={togglePanel}
          className="flex items-center space-x-1.5 px-3 py-1.5 rounded-lg font-mono text-xs transition-all duration-200"
          style={{
            background: isPanelOpen ? 'rgba(0, 255, 0, 0.2)' : 'rgba(0, 255, 0, 0.1)',
            border: '1px solid rgba(0, 255, 0, 0.3)',
            color: '#00ff00',
            textShadow: '0 0 5px rgba(0, 255, 0, 0.5)',
          }}
        >
          <Terminal className="w-3 h-3" />
          <span>GEEK</span>
          {isPanelOpen ? <ChevronRight className="w-3 h-3" /> : <ChevronLeft className="w-3 h-3" />}
        </button>
      )}
    </div>
  )
}
